import { render } from "./FilterDeals.vue?vue&type=template&id=b9a0264c&ts=true"
import script from "./FilterDeals.vue?vue&type=script&lang=ts"
export * from "./FilterDeals.vue?vue&type=script&lang=ts"

import "./FilterDeals.vue?vue&type=style&index=0&id=b9a0264c&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__